import { AttachmentConstants } from './attachmentConstants';
import AttachmentFile, { AttachmentFileType } from '../types/AttachmentFile';
import AttachmentItemFile from '../types/AttachmentItemFile';
import CloudFile from '../types/CloudFile';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import ReferenceAttachment from 'owa-service/lib/contract/ReferenceAttachment';

/**
 * This creates an AttachmentFile from an attachment that already exists in a users mailbox
 * Reference Attachments that already exist in the users mailbox are represented as cloudy files with a Mailbox provider
 * Non-Reference attachments that exist in the users mailbox are represented as attachmentItem files
 * @param attachment an attachment that exists in the users mailbox
 */
export default function createAttachmentFileFromExistingMailboxAttachment(
    attachment: AttachmentType
): AttachmentFile {
    const attachmentId = attachment.AttachmentId!.Id || '';
    if (attachment.__type === AttachmentConstants.attachmentTypes.REFERENCE_ATTACHMENT_TYPE) {
        const refAttachment = attachment as ReferenceAttachment;
        const cloudFile: CloudFile = {
            fileType: AttachmentFileType.Cloud,
            name: refAttachment.Name!,
            size: refAttachment.Size!,
            providerId: '',
            providerType: AttachmentDataProviderType.Mailbox,
            location: refAttachment.AttachLongPathName!,
            providerEndpointUrl: '',
            isFolder: false,
            thumbnailUrl: refAttachment.AttachmentThumbnailUrl!,
            previewUrl: refAttachment.AttachmentPreviewUrl!,
            fileId: attachmentId,
            fileParentId: '',
            type: refAttachment.__type!,
        };
        return cloudFile;
    } else {
        const attachmentItemFile: AttachmentItemFile = {
            attachmentItemId: attachmentId,
            name: attachment.Name!,
            size: attachment.Size!,
            fileType: AttachmentFileType.AttachmentItem!,
            type: AttachmentConstants.attachmentTypes.ITEM_ID_ATTACHMENT_TYPE!,
        };
        return attachmentItemFile;
    }
}
